/**
 * SpotGo UI Messages
 */

export const SPOT_MESSAGES = {
    // Authentication & Permissions
    LOGIN_REQUIRED: "spot_login_required",
    GUEST_RESTRICTION: "spot_guest_restriction",
    PERMISSION_DENIED: "spot_permission_denied",
    PERMISSION_BLOCKED: "spot_permission_blocked",
    LOCATION_ERROR: "spot_location_error",

    // Validation
    INPUT_REQUIRED: "spot_input_required",
    COOLDOWN_WAIT: "spot_cooldown_wait",
    PHOTO_LIMIT_EXCEEDED: "spot_photo_limit", // Dynamic: { type, count }

    // Location Permission
    LOC_PERMISSION_TITLE: "spot_loc_permission_title",
    LOC_PERMISSION_DESC: "spot_loc_permission_desc",
    LOC_PERMISSION_DENY: "spot_loc_permission_deny",
    LOC_PERMISSION_ALLOW: "spot_loc_permission_allow",

    // Action Buttons
    BTN_LIKE: "spot_btn_like",
    BTN_VERIFY: "spot_btn_verify",

    // Verification
    VERIFY_CONFIRM: "spot_verify_confirm", // Dynamic: { title, cost }
    ALREADY_VERIFIED: "spot_already_verified",
    VERIFICATION_SUCCESS: "spot_verification_success",
    PAYMENT_UNAVAILABLE: "spot_payment_unavailable",
    PAYMENT_CANCELLED: "spot_payment_cancelled",
    INSUFFICIENT_FUNDS: "spot_insufficient_funds",
    INSUFFICIENT_TICKETS: "spot_insufficient_tickets",

    // CRUD Operations
    REG_SUCCESS: "spot_reg_success", // Dynamic: { type }
    DELETE_SPOT_CONFIRM: "spot_delete_spot_confirm",
    DELETE_SPOT_SUCCESS: "spot_delete_spot_success",
    EDIT_SUCCESS: "spot_edit_success",
    REG_FAIL: "spot_reg_fail", // Dynamic: { message }

    // Comments
    DELETE_COMMENT_CONFIRM: "spot_delete_comment_confirm",
    DELETE_COMMENT_SUCCESS: "spot_delete_comment_success",
    EDIT_COMMENT_EMPTY: "spot_edit_comment_empty",
    EDIT_COMMENT_SUCCESS: "spot_edit_comment_success",
    COMMENT_ADDED: "spot_comment_added",

    // Likes
    LIKE_SUCCESS: "spot_like_success",
    LIKE_CANCEL: "spot_like_cancel",
    LIKE_ERROR: "spot_like_error",

    // Empty States
    EMPTY_DATA: "spot_empty_data",

    // UI Terms
    TYPE_STORE: "spot_type_store",
    TYPE_POST: "spot_type_post",
    LOADING: "spot_loading",

    LOCATION_CHECKING: "spot_location_checking",
    CHECKING_PERMISSION: "spot_checking_permission", // 🎯 [UI] 권한 확인 중 메시지
    PI_BROWSER_ONLY: "spot_pi_browser_only",
    CONNECTING: "spot_connecting",
    PI_LOGIN_FAILED: "spot_pi_login_failed",
    TYPE_STORE_OFFICIAL: "spot_type_store_official",
    TYPE_LANDMARK: "spot_type_landmark",
    TYPE_FOOTPRINT: "spot_type_footprint",
    RADAR_COUNT: "spot_radar_count",

    // Sort & Filters
    SORT_POPULAR: "spot_sort_popular",      // 변경: 관련도순 → 인기순
    SORT_NEWEST: "spot_sort_newest",         // 신규: 최신순
    SORT_DISTANCE: "spot_sort_distance",
    FILTER_MY_POSTS: "spot_filter_my_posts",
    FILTER_MY_COMMENTS: "spot_filter_my_comments",
    FILTER_MY_MENU: "spot_filter_my_menu",
    FILTER_MY_STORE: "spot_filter_my_store",
    FILTER_MY_LAND: "spot_filter_my_land", // ✅ Phase 3
    FILTER_CLEAR: "spot_filter_clear",

    // Registration Modal
    REG_SELECT_TYPE: "spot_reg_select_type",
    TICKET_OWNED: "spot_ticket_owned", // Dynamic: {count}
    REG_TYPE_POST: "spot_reg_type_post",
    REG_TYPE_STORE: "spot_reg_type_store",
    REG_TYPE_MY_LAND: "spot_reg_type_my_land",
    REG_MY_LAND_NO_TICKET: "spot_reg_my_land_no_ticket",
    REG_TITLE_STORE: "spot_reg_title_store",
    REG_TITLE_POST: "spot_reg_title_post",
    REG_PLACEHOLDER_TITLE: "spot_reg_placeholder_title",
    REG_PLACEHOLDER_CONTENT: "spot_reg_placeholder_content",
    REG_ADD_PHOTO: "spot_reg_add_photo", // Dynamic: {current, max}
    REG_WARNING_STORE: "spot_reg_warning_store",
    REG_WARNING_POST: "spot_reg_warning_post",
    REG_SUBMIT_STORE: "spot_reg_submit_store",
    REG_SUBMIT_POST: "spot_reg_submit_post",
    LOADING_REG_STORE: "spot_loading_reg_store",
    LOADING_REG_POST: "spot_loading_reg_post",

    // Edit & Actions
    EDIT_TITLE_STORE: "spot_edit_title_store",
    EDIT_TITLE_POST: "spot_edit_title_post",
    INPUT_TITLE: "spot_input_title",
    EDIT_IMAGE_LABEL: "spot_edit_image_label",
    IMAGE_LIMIT_ALERT: "spot_image_limit_alert",
    EDIT_IMAGE_NOTE: "spot_edit_image_note",
    STATUS_RENEWAL_NEEDED: "spot_status_renewal_needed",
    RENEWAL_TITLE_POST: "spot_renewal_title_post",
    RENEWAL_TITLE_STORE: "spot_renewal_title_store",
    RENEWAL_DESC_POST: "spot_renewal_desc_post",
    RENEWAL_DESC_STORE: "spot_renewal_desc_store",
    EXPIRES_IN: "spot_expires_in",
    VIEW_ON_MAP: "spot_view_on_map",
    TOP5_EMPTY_POSTS: "spot_top5_empty_posts",
    TOP5_EMPTY_STORES: "spot_top5_empty_stores",
    EMPTY_DATA_REFRESH: "spot_empty_data",
    TOP5_EMPTY_LANDMARKS: "spot_top5_empty_landmarks",

    // Comments & General UI
    COMMENT_COUNT: "spot_comment_count", // Dynamic: {count}
    COMMENT_FIRST: "spot_comment_first",
    COMMENT_PLACEHOLDER: "spot_comment_placeholder",
    COMMENT_COOLDOWN: "spot_comment_cooldown", // 🎯 [NEW] Dynamic: {seconds}
    CONFIRM: "spot_confirm",
    CANCEL: "spot_cancel",
    NEXT: "spot_next",
    PREV: "spot_prev",
    SAVE: "spot_save",
    EDIT: "spot_edit",
    DELETE: "spot_delete",
    FEATURES_READY: {
        SEARCH: "spot_feature_search_ready",
        NOTIFICATION: "spot_feature_notification_ready"
    },

    // 🎯 Treasure Hunt Mode
    TREASURE_HINT: "spot_treasure_hint",
    TREASURE_DISTANCE: "spot_treasure_distance", // Dynamic: {distance}
    TREASURE_FOUND: "spot_treasure_found"
};

export default SPOT_MESSAGES;
